import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, QueryList, Renderer2, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { DropDownOption } from 'src/app/shared/models/forms/dropdown-option';

@Component({
  selector: 'app-form-dropdown',
  templateUrl: './form-dropdown.component.html',
  styleUrl: './form-dropdown.component.scss'
})
export class FormDropdownComponent implements OnInit {

  @ViewChildren("ddlItem") ddlItems: QueryList<ElementRef>;
  @ViewChild("ddlInput") ddlInput: ElementRef;
  @ViewChild("ddlList") ddlList: ElementRef;
  @ViewChild('ddlTemplate', { static: true }) ddlTemplate: TemplateRef<any>;

  @HostListener('focusout', ['$event.target']) onFocusout(e: any) {
    console.log('blur', e);
    this.selectionActive = false;
    this.highlightedItem = 0;

    setTimeout(() => {
      this.renderer.setStyle(this.ddlList.nativeElement, 'display', 'none');
    }, 200);
  }

  @Output() onDropDownSelectionChange: EventEmitter<any> = new EventEmitter();

  private _selectedItem: DropDownOption<any>;
  public get selectedItem(): DropDownOption<any> {
    return this._selectedItem;
  }
  public set selectedItem(value: DropDownOption<any>) {
    this._selectedItem = value;
  }

  public filterText: string;

  private selectionActive: boolean = false;
  private highlightedItem: number = 0;
  public filteredOptions: DropDownOption<any>[] = [];
  public dropDownPlaceHolderText: string;

  @Input('options') options: DropDownOption<any>[] = [];
  @Input('categoryName') categoryName: string;


  constructor(
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) {

  }
  ngOnInit(): void {
    this.dropDownPlaceHolderText = `Select your ${this.categoryName}`;
  }

  public expand() {
    this.renderer.setStyle(this.ddlList.nativeElement, 'display', 'block');
    this.ddlInput.nativeElement.focus();
    this.filterItems();
  }

  public filterItems() {

    // Reset keyboard highlight
    this.highlightedItem = 0;
    this.selectionActive = false;

    // Perform filter
    if (!this.filterText || this.filterText == '') {
      this.filteredOptions = this.options;
    }
    else {
      this.filteredOptions = this.options.filter(
        item => item.value.toLowerCase().includes(this.filterText.toLowerCase())
          || (item.grouping && item.grouping.toLowerCase().includes(this.filterText.toLowerCase()))
      );
    }

    setTimeout(() => {
      this.renderer.setStyle(this.ddlList.nativeElement, 'display', 'block');
    }, 0);

  }

  public choose(item: DropDownOption<any>) {

    this.selectedItem = null;
    this.onDropDownSelectionChange.next(item.data);

    item.isSelected = true;
    this.reset();
    this.renderer.setStyle(this.ddlList.nativeElement, 'display', 'none');
  }

  public reset() {
    this.filterText = '';
    this.selectionActive = false;
    this.highlightedItem = 0;
    this.filteredOptions.forEach(element => {
      element.isSelected = false;
    });
    this.ddlInput.nativeElement.focus();
  }

  public onKeyDown(event: KeyboardEvent) {

    this.filteredOptions.forEach(element => {
      element.isSelected = false;
    });

    if (event.key === "ArrowUp" && this.selectionActive == false) {
      console.log("Up arrow key pressed");
      this.selectionActive = true;
    }

    if (event.key === "ArrowUp" && this.highlightedItem >= 1) {
      console.log("Up arrow key pressed");

      this.highlightedItem--;
      this.selectionActive = true;
      this.scroll(this.highlightedItem, 0);
    }

    if (event.key === "ArrowDown" && this.highlightedItem < this.filteredOptions.length - 1) {
      console.log("Down arrow key pressed", this.highlightedItem);

      this.selectionActive == false ? this.highlightedItem = 0 : this.highlightedItem++;
      this.selectionActive = true;
      this.scroll(this.highlightedItem, 1);
    }

    console.log('this.highlightedItem', this.highlightedItem);

    if (this.filteredOptions.length > 0) {
      this.filteredOptions[this.highlightedItem].isSelected = true;
    }

    if (this.filteredOptions.length == 1) {
      this.filteredOptions[0].isSelected = true;

    }

    if (event.key === "Enter" && this.selectionActive == true) {
      this.choose(this.filteredOptions[this.highlightedItem]);
      this.reset();
    }
  }


  public scroll(item: number, direction: number) {
    if (!this.canScroll) {
      return;
    }

    // Get the height of an item.
    const itemHeight = this.ddlItems.first.nativeElement.offsetHeight;

    // Get the height of the div.
    const listHeight = this.ddlList.nativeElement.offsetHeight;

    const div = this.ddlList.nativeElement;
    console.log('div.scrollTop', div.scrollTop);

    console.log('((item-1) * itemHeight)', ((item - 1) * itemHeight));

    if (direction == 0) {
      if (((item - 1) * itemHeight) < div.scrollTop) {
        div.scrollTop -= itemHeight;
      }
    }
    else {
      if (((item + 1) * itemHeight) > listHeight) {
        div.scrollTop += itemHeight;
      }
    }

  }

  public canScroll(): boolean {

    // Get the height of an item.
    const itemHeight = this.ddlItems.first.nativeElement.offsetHeight;

    // Get the height of the div.
    const listHeight = this.ddlList.nativeElement.offsetHeight;

    if (itemHeight * this.filteredOptions.length > listHeight) {
      return true;
    }
    else {
      return false;
    }
  }

}
